import React from "react";
import { withRouter } from "react-router-dom";
import { Body } from "../Certificates";
import Layout from "../../Components/Layout";
import Navigation from "./Components/Navigation";
import { NavStrip, HelmetTitle } from "../../Components/Utils";

import SecurityBoxes from "./Pages/SecurityBoxes";
import EcosystemSection from "./Pages/Ecosystem";
import GersProjects from "./Pages/GersProjects";
import EcosystemLogos from "../GERSModel/Ecosystem";

import SecurityOnlineMD from "./Contents/SecurityOnline.md";
import SecurityServicesMD from "./Contents/SecurityServices.md";
import CyberResourcesMD from "./Contents/CyberResources.md";
import GERSPrinciplesMD from "./Contents/GersPrinciples.md";
import ResourcesMD from "./Contents/ResourcesMarkdown.md";
import "./index.css";

class GERSServices extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentDidUpdate(prevProps) {
    if(prevProps.match.params.type !== this.props.match.params.type) {
    window.scrollTo(0, 0);
    }
  }
  getPage (servicePage) {
    const pageParam = servicePage.toLowerCase();
    switch (pageParam) {
      case "cybersecurity":
        return SecurityOnlineMD;
      case "assets":
        return CyberResourcesMD;
      case "security":
        return SecurityServicesMD;
      case "gers-principles":
        return GERSPrinciplesMD;
      case "resources":
        return ResourcesMD;
      default:
        return false;
    }
  }
  isPage(page) {
    const servicePage = page.toLowerCase();
    switch (servicePage) {
      case "cybersecurity":
        return <SecurityBoxes />
      case "ecosystem-charter":
        return <EcosystemSection />
      case "global-projects":
        return <GersProjects />
      case "principles-project":
        return <GersProjects isPrinciple />
      case "ecosystem":
        return <EcosystemLogos />
      default:
        return false;
    }
  }
  render() {        
    const servicePage = this.props.match.params.type;
    return (
      <div className="App">
        <HelmetTitle title={servicePage.toLowerCase().charAt(0).toUpperCase() + servicePage.slice(1)} />
        <Layout
          head={
            <React.Fragment>
              <Navigation />
              <NavStrip />
            </React.Fragment>
          }
          body={ 
            <React.Fragment>
              {
                this.isPage(servicePage)
              }             
              {
                this.getPage(servicePage) &&
                <Body markdownPath={this.getPage(servicePage)} />
              }
            </React.Fragment>
          }
        />
      </div>  
    );
  }    
}

export default withRouter(GERSServices)



// WEBPACK FOOTER //
// ./src/Pages/BannerItems/index.js